import { Pipe, PipeTransform } from '@angular/core';
import { Tag } from '@zero/tags/domain';

@Pipe({
  name: 'tagNameFilter',
  standalone: true,
})
export class TagNameFilterPipe implements PipeTransform {
  public transform(tags: Tag[], tagName: string): Tag[] {
    return tagName ? tags.filter((tag) => tag.name.toLowerCase().includes(tagName.toLowerCase())) : tags;
  }
}
